module.exports = __webpack_public_path__ + "static/img/1.7e774a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/1.png
// module id = Ik5L
// module chunks = 0